<div class="authentication" >
  @if (authMethodEnabled('digid_preview') || authMethodEnabled('idin_preview') || authMethodEnabled('irma_preview') || authMethodEnabled('mouse_preview') || authMethodEnabled('smstan_preview') || authMethodEnabled('sso_preview') || authMethodEnabled('csc_preview')) {
    <em class="fas fa-lock mr-2"
      [ngClass]="hasAuthMethod('digid', true) || hasAuthMethod('idin', true) || hasAuthMethod('irma', true) || hasAuthMethod('mouse',true) || hasAuthMethod('smstan',true) || hasAuthMethod('sso',true) || hasAuthMethod('csc',true)?'text-primary':'text-gray-light'"
    title="{{'signrequest.am.preview' | translate}}"></em>
  }

  @if (authMethodEnabled('mouse')) {
    <em class="fas fa-mouse mr-2"  [ngClass]="hasAuthMethod( 'mouse', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.mouse' | translate}}"></em>
  }
  @if (authMethodEnabled('smstan')) {
    <em class="fas fa-sms mr-2 " [ngClass]="hasAuthMethod('smstan', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.smstan' | translate}}"></em>
  }
  @if (authMethodEnabled('idin')) {
    <em class="fas fa-money-check mr-2" [ngClass]="hasAuthMethod('idin', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.idin' | translate}}"></em>
  }
  @if (authMethodEnabled('irma')) {
    <em class="fas fa-id-card mr-2"  [ngClass]="hasAuthMethod( 'irma', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.irma' | translate}}"></em>
  }
  @if (authMethodEnabled('digid')) {
    <em class="fas fa-user mr-2" [ngClass]="hasAuthMethod( 'digid', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.digid' | translate}}"></em>
  }
  @if (authMethodEnabled('checkedid')) {
    <em class="fas fa-passport mr-2" [ngClass]="hasAuthMethod( 'checkedid', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.checkedid' | translate}}"></em>
  }
  @if (authMethodEnabled('csc')) {
    <em class="fas fa-certificate mr-2" [ngClass]="hasAuthMethod( 'csc', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.csc' | translate}}"></em>
  }
  @if (authMethodEnabled('documenttemplate')) {
    <em class="fas fa-signature mr-2" [ngClass]="hasAuthMethod( 'documenttemplate', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.document_template' | translate}}"></em>
  }
  @if (authMethodEnabled('document_anchors')) {
    <em class="fas fa-anchor mr-2" [ngClass]="hasAuthMethod( 'document_anchors', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.document_anchors' | translate}}"></em>
  }
  @if (authMethodEnabled('certificate')) {
    <em class="fas fa-certificate mr-2" [ngClass]="hasAuthMethod( 'certificate', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.certificate' | translate}}"></em>
  }
  @if (authMethodEnabled('sso')) {
    <em class="fas fa-user mr-2" [ngClass]="hasAuthMethod( 'sso', false)?'text-primary':'text-gray-light'" title="{{'signrequest.am.sso' | translate}}"></em>
  }
</div>
